import React from 'react'

const PartnersContext = React.createContext()

export default PartnersContext
